// react
import React, { useState } from 'react';

// components
import { ExpandMore } from '@/components/atoms/ExpandMore/ExpandMore';

// mui
import {
  Collapse,
  Link,
  ListItemButton,
  Stack,
  Typography,
} from '@mui/material';

interface SimpleAccordionProps {
  children: React.ReactNode;
  title?: string;
}

export const SimpleAccordion = ({ children, title }: SimpleAccordionProps) => {
  // state
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Stack>
      <ListItemButton
        sx={{
          borderRadius: 1,
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography variant='subtitle2'>{title}</Typography>
        <ExpandMore
          isExpanded={isExpanded}
          aria-expanded={isExpanded}
          aria-label={`show more details about ${title}`}
        />
      </ListItemButton>
      <Collapse in={isExpanded}>
        <Stack
          spacing={1}
          sx={{
            paddingX: 2,
            paddingY: 1,
          }}
        >
          {children}
        </Stack>
      </Collapse>
    </Stack>
  );
};

SimpleAccordion.displayName = 'SimpleAccordion';
export default SimpleAccordion;
